import { Avatar } from "@radix-ui/themes";
import type { ComponentPropsWithoutRef } from "react";
import FontAwesome, { FontAwesomeSize } from "./FontAwesome";

interface UserAvatarProps {
  avatarUrl?: string;
  fname?: string | null;
  lname?: string | null;
  size?: "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9";
  alt?: string;
  avatarProps?: Omit<
    ComponentPropsWithoutRef<typeof Avatar>,
    "src" | "alt" | "fallback" | "radius" | "color" | "size"
  >;
}

export function UserAvatar({
  avatarUrl,
  fname,
  lname,
  size = "3",
  alt,
  avatarProps = {},
}: UserAvatarProps) {
  const first = fname ? fname.charAt(0) : "";
  const last = lname ? lname.charAt(0) : "";
  const initials = (first + last).toUpperCase();
  const altText =
    alt || [fname, lname].filter(Boolean).join(" ") || "User avatar";

  let faSize: FontAwesomeSize | undefined = undefined;
  switch (size) {
    case "3":
    case "4":
    case "5":
      break;
    case "6":
    case "7":
      faSize = "2x";
      break;
    case "8":
    case "9":
      faSize = "3x";
  }

  const fallback = initials ? (
    initials
  ) : (
    <FontAwesome
      name="fa-user"
      prefix="fas"
      size={faSize}
      aria-label={altText}
    />
  );

  return (
    <Avatar
      src={avatarUrl}
      alt={altText}
      fallback={fallback}
      radius="full"
      color="gray"
      size={size}
      {...avatarProps}
    />
  );
}
